import { accessibleShade, typeSize } from "@coaching-culture/ui";
import { useGoalTerminology } from "auth/OrgProvider";
import CenterColumn from "components/CenterColumn";
import { PageHeader } from "components/PageHeader";
import { FaChevronLeft } from "react-icons/fa";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { GoalReview } from "./GoalReview";

/** Matches PageHeader's back link, but goes back in history: this page is
 * reached from several places. */
const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: ${typeSize("small")};
  font-weight: 600;
  color: ${(p) => accessibleShade(p.theme.colors.primary)};

  & svg {
    font-size: 10px; /* design-lint-ignore: chevron sized like PageHeader's */
  }
`;

export const GoalReviewContainer = () => {
  const { id, userId } = useParams<{
    id: string;
    userId: string;
  }>();
  const terms = useGoalTerminology();
  const history = useHistory();

  return (
    <CenterColumn>
      <BackLink
        onClick={(ev) => {
          ev.preventDefault();
          history.goBack();
        }}
        to={null}
      >
        <FaChevronLeft aria-hidden="true" />
        Back
      </BackLink>
      <PageHeader
        text={`${terms.goal.asTitle()} Management`}
        subtitle={`Edit ${terms.goal.asBody()} details and review your progress`}
      />

      <GoalReview userId={userId} goalId={id} />
    </CenterColumn>
  );
};
